import { safeReturnTo } from '@garagegymbros/domain';

function callbackError(params: URLSearchParams): string | null {
  const description = params.get('error_description')?.trim();
  if (description) return description;
  const reason = params.get('error_code')?.trim() || params.get('error')?.trim();
  return reason ? `Authentication failed (${reason}). Request a new link and try again.` : null;
}

/** Read only the callback fields we use; never retain or log fragment tokens. */
export function parseAuthCallback(search: string, hash = '') {
  const query = new URLSearchParams(search);
  const fragment = new URLSearchParams(hash.replace(/^#/, ''));
  return {
    code: query.get('code'),
    error: callbackError(query) ?? callbackError(fragment),
    next: safeReturnTo(query.get('next')),
  };
}

/** A one-use PKCE code can be handed to iOS; session tokens are never forwarded. */
export function nativeAuthLink(search: string): string | null {
  const { code, error } = parseAuthCallback(search);
  const values = new URLSearchParams(search);
  if (error || !code || code.length > 1024 || /\s/.test(code) || values.getAll('code').length !== 1)
    return null;
  return `garagegymbros://auth/callback?code=${encodeURIComponent(code)}`;
}
